"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Ref, Mixins } from "vue-property-decorator";
import _ from "lodash";
import { AccountSessionMixins } from "@/service/account-session";
import UiGrid, { GridController } from "@/components/grid/UiGrid.vue";
import { APIDataSource } from "@/components/grid/data-source";
import DateFormat from "@/framework/timeformatter";
import UiDialog from "@/components/dialog/UiDialog.vue";
import UiForm, { UiFormController } from "@/components/form/UiForm.vue";
import UiSubmit from "@/components/form/UiSubmit.vue";
import API from "@ym-framework/api-utils";
import Question from "@/components/Question.vue";
class invoiceInfoController extends UiFormController {
  constructor() {
    super(...arguments);
    // @UiFormAnnotations.Rule([
    //   {
    //     required: true,
    //     message: i18n.t('invoice_info.invoice_number_tip') as string,
    //     trigger: "blur"
    //   }
    // ])
    this.invoice_number = "";
    this.invoice_title = "";
    this.invoice_bank = "";
    this.bank_account = "";
    // public company_phone:string = "";
    // public company_address:string = "";
    // public invoice_address:string = "";
    // public invoice_phone:string = "";
    this.own_name = "";
    this.own_email = "";
    this.own_receiver = "";
    this.own_phone = "";
    this.own_address = "";
  }
}
let InvoiceManage = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.controller = new invoiceInfoController();
    this.searchDate = [
      new Date(new Date().setDate(new Date().getDate() - 7)),
      new Date()
    ];
    // gridController = new GridController<InvoiceRecord>(
    //   new APIDataSource("api://base.auth/api/v8/invoice_reqeusts")
    // );
    // base.auth.pro
    this.gridController = new GridController(
      new APIDataSource("api://base.auth.pro/v1/invoice-request")
    );
    this.pickerOptions = {
      shortcuts: [
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.today"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(new Date(start.toLocaleDateString()).getTime());
            picker.$emit("pick", [start, end]);
          }
        },
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.lastday"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(new Date(start.toLocaleDateString()).getTime() - 3600 * 1e3 * 24);
            start.setHours(0, 0, 0, 0);
            end.setTime(new Date(end.toLocaleDateString()).getTime());
            picker.$emit("pick", [start, end]);
          }
        },
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.thisweek"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - (start.getDay() - 1) * 3600 * 1e3 * 24);
            start.setHours(0, 0, 0, 0);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.lastsevenday"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1e3 * 24 * 7);
            start.setHours(0, 0, 0, 0);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.lastweek"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - (start.getDay() + 6) * 3600 * 1e3 * 24);
            start.setHours(0, 0, 0, 0);
            end.setTime(end.getTime() + (0 - end.getDay()) * 3600 * 1e3 * 24);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.thismonth"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.setDate(1));
            start.setHours(0, 0, 0, 0);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.lastthirtydays"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1e3 * 24 * 30);
            start.setHours(0, 0, 0, 0);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.lastmonth"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(new Date(start.setMonth(start.getMonth() - 1)).setDate(1));
            start.setHours(0, 0, 0, 0);
            end.setTime(end.setDate(1));
            picker.$emit("pick", [start, end]);
          }
        }
      ],
      disabledDate(time) {
        return time.getTime() > new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1e3 - 1) || time.getTime() < new Date(new Date().setMonth(new Date().getMonth() - 6));
      }
    };
    this.searchParams = {
      search: ""
    };
    this.searchByDate = _.debounce((searchDate) => __async(this, null, function* () {
      if (searchDate !== null && searchDate.length !== 0) {
        console.log(searchDate);
        let mintime = DateFormat.ToSecond(Date.parse(searchDate[0]));
        let maxtime = DateFormat.ToSecond(Date.parse(searchDate[1]));
        this.gridController.query.params = {
          search: `startTime=ge=${mintime};endTime=le=${maxtime}`
        };
        yield this.gridController.search();
        return;
      } else {
        this.gridController.query.params = null;
        yield this.gridController.search();
      }
    }), 500);
  }
  // searchParams: any = {
  //   search: {},
  //   select: null,
  // };
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
      try {
        this.gridController.query.params = this.searchParams;
        yield this.searchByDate(this.searchDate);
        yield this.getInvoiceInfo();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  getInvoiceInfo() {
    return __async(this, null, function* () {
      try {
        let response = yield API.get(`api://base.auth.pro/v1/invoice`);
        console.log(response.data);
        this.controller.invoice_title = response.data.invoiceTitle;
        this.controller.invoice_number = response.data.invoiceTaxpayerNumber;
        this.controller.own_email = response.data.invoiceEmail;
        this.controller.own_receiver = response.data.invoiceConsignee;
        this.controller.own_phone = response.data.invoicePhone;
        this.controller.own_address = response.data.invoiceAddress;
        this.controller.own_name = response.data.invoiceName;
        this.controller.invoice_bank = response.data.invoiceDepositBank;
        this.controller.bank_account = response.data.invoiceAccount;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  submitInvoiceInfo() {
    return __async(this, null, function* () {
      try {
        yield API.post(`api://base.auth.pro/v1/invoice`, {
          "invoiceTitle": this.controller.invoice_title,
          "invoiceTaxpayerNumber": this.controller.invoice_number,
          "invoiceEmail": this.controller.own_email,
          "invoiceConsignee": this.controller.own_receiver,
          "invoicePhone": this.controller.own_phone,
          "invoiceAddress": this.controller.own_address,
          "invoiceName": this.controller.own_name,
          "invoiceDepositBank": this.controller.invoice_bank,
          "invoiceAccount": this.controller.bank_account
        });
        this.$message.success(this.$t("invoice.edit_success_info"));
        this._invoice_info.hide();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  refresh() {
    return __async(this, null, function* () {
      this.gridController.query.params = this.searchParams;
      yield this.gridController.search();
    });
  }
  openInvoiceDetail(data) {
    return __async(this, null, function* () {
      let downloadWin = window.open("", "_blank");
      if (data !== null || data !== "") {
        downloadWin.location.href = data;
      }
    });
  }
  formate_time(time) {
    if (time === 0 || time === null || time === void 0) {
      return "--";
    } else {
      return DateFormat.dateformatterDay(DateFormat.check(time));
    }
  }
  openInvoiceInfo() {
    return __async(this, null, function* () {
      try {
        yield this.getInvoiceInfo();
        this._invoice_info.show();
      } catch (error) {
      }
    });
  }
  cancelInvoice() {
    this._invoice_info.hide();
  }
  goHelp(no) {
    window.open(`https://www.kuajingvs.com/help2/${no}`);
  }
};
__decorateClass([
  Ref("invoice-info")
], InvoiceManage.prototype, "_invoice_info", 2);
InvoiceManage = __decorateClass([
  Component({
    components: {
      UiGrid,
      UiDialog,
      UiForm,
      UiSubmit,
      Question
    }
  })
], InvoiceManage);
export {
  InvoiceManage as default
};
